import type { Localizations, LocalizationsProvider } from "~/service/l10n";
import { theme_ns } from "./theme";

const translations = {
    'en-US': {
        'common.today':'Today',
        'common.back': 'Back',
        'common.benefits': 'Benefits',
        'common.next': 'Next',
        'common.ok': 'OK',
        'common.previous': 'Previous',
        'common.readMore': 'Read more',
        'common.readMoreFacebook': 'Read more',
        'common.privacyPolicy': 'Privacy policy',
        'common.downloadApp': 'Download app',
        'common.buyGiftCards': 'Buy gift cards',
        'common.orderNewsLetter': 'Order newsletter',
        'common.seeOpeningHours': 'Opening hours',
        'common.howToArrive': 'How to arrive',
        'common.floormap': 'Floormap',
        'common.openFloormap': 'Open floor map',
        'common.storesOpenedAtLeast': 'Stores open today at least',
        'common.whatsNew': 'What\'s new',
        'common.viewMore': 'View more',
        'common.viewLess': 'View less',
        'common.viewMoreNews': 'View more news',
        'common.tomorrow': 'Tomorrow',
        'common.dateSelector': 'Select date',
        'common.coming': 'Coming',
        'cookie.policy': 'Our site uses cookies to guarantee the best user experience. By continuing the use of the site you accept the use of cookies.',
        'dayAgo': 'day ago',
        'daysAgo': 'days ago',
        'hourAgo': 'hour ago',
        'hoursAgo': 'hours ago',
        'weekAgo': 'week ago',
        'weeksAgo': 'weeks ago',
        'week': 'week',
        'events.latestEvents': 'Latest news',
        'events.events': 'News and events',
        'events.otherEvents': 'Other events and news',
        'events.published': 'Published',
        'feedback.email': 'Email',
        'feedback.emailShort': 'Email',
        'feedback.feedback': 'Feedback',
        'feedback.general': 'General feedback',
        'feedback.name': 'Name',
        'feedback.required': 'Required field',
        'feedback.requiresResponse': 'I would like to receive a response',
        'feedback.specific': 'Feedback to a specific company',
        'feedback.thanks': 'Thank you for your feedback!',
        'feedback.title': 'Give feedback',
        'feedback.type': 'Type of feedback',
        'feedback.types.COMPLAINT': 'Complaint',
        'feedback.types.OTHER': 'Other',
        'feedback.types.SUGGESTION': 'Suggestion',
        'feedback.types.THANKS': 'Thanks',
        'feedback.invalid': 'Invalid email address',
        'feedback.failedSubmit': 'Make sure you have filled all required fields, and that you have verified you are not a robot.',
        'lunch.lunch': 'Lunch',
        'lunch.lunchTime': 'Lunch time',
        'lunch.lunchToday': 'Lunch today',
        'lunch.openMenu': 'Open menu (pdf)',
        'lunch.noMenu': 'No lunch menu',
        'lunch.today': 'Today',
        'lunch.orderFoodOnline': 'Order food online',
        'lunch.bookTable': 'Book a table',
        'lunch.allRestaurant': 'See all restaurants',
        'lunch.orderFoodFromUs': 'From us you can also order food home!',
        'lunch.lunchList': 'Lunch list',
        'lunch.toRestaurantPage': 'Go to restaurant page',
        'lunch.searchLunchRestaurant': 'Search restaurant',
        'lunch.viewMore': 'More restaurants',
        'offers.allOffers': 'All offers',
        'offers.closeOffer': 'Close',
        'offers.seeWholeOffer': 'See whole offer',
        'offers.noOffers': 'Unfortunately no offers are currently available',
        'offers.noContent': 'No content currently available',
        'offers.fromCenter': 'From center',
        'offers.fromStores': 'From stores',
        'offers.moreOffers': 'See more offers',
        'offers.moreAboutOffer': 'More about offer',
        'offers.valid': 'valid',
        'openinghours.monday.short': 'Mon',
        'openinghours.monday': 'Monday',
        'openinghours.tuesday.short': 'Tue',
        'openinghours.tuesday': 'Tuesday',
        'openinghours.wednesday.short': 'Wed',
        'openinghours.wednesday': 'Wednesday',
        'openinghours.thursday.short': 'Thu',
        'openinghours.thursday': 'Thursday',
        'openinghours.friday.short': 'Fri',
        'openinghours.friday': 'Friday',
        'openinghours.saturday.short': 'Sat',
        'openinghours.saturday': 'Saturday',
        'openinghours.sunday.short': 'Sun',
        'openinghours.sunday': 'Sunday',
        'openinghours.openedToday': 'Open today',
        'openinghours.closedToday': 'Closed today',
        'openinghours.openedTomorrow': 'Open tomorrow',
        'openinghours.closedTomorrow': 'Closed tomorrow',
        'openinghours.openedDayAfter': 'Open the day after',
        'openinghours.closedDayAfter': 'Closed the day after',
        'openinghours.dayAfter': 'Day after',
        'openinghours.seeAllCentreOpeningHours': 'See all centre opening hours',
        'openinghours.displayAll': 'See all opening hours',
        'openinghours.title': 'Opening hours',
        'search.articles': 'Article',
        'search.stores': 'Store',
        'search.events': 'News',
        'search.noResults': 'No results',
        'search.placeholder': 'Search',
        'search.forFood': 'Search for restaurant, café or pub',
        'search.forBrand': 'Search for store or service',
        'search.forOffers': 'Your best offer.',
        'store.allStores': 'All Stores',
        'store.allFloors': 'All Floors',
        'store.allRestaurants': 'All Cafés and restaurants',
        'store.closed': 'Closed',
        'store.status.CLOSED': "Closed",
        'store.status.OPEN': "Open",
        'store.contact': 'Contact information',
        'store.contactForm': 'Contact us',
        'store.contactPrivatePolicyText': 'When you send a message, the store may contact you by email. We will not use your information for other purposes. By sending the form you agree to our',
        'store.message': 'Message',
        'store.exceptionalOpeningHours': 'Exceptional opening hours',
        'store.seeExceptHours': 'See exceptional opening hours',
        'store.filterSearch': 'Filter results',
        'store.location': 'Location on map',
        'store.lunch': 'Lunch',
        'store.openLunchMenu': 'Lunch menu >',
        'store.lunchMenu': 'Lunch menu',
        'store.offers': 'Store benefits',
        'store.openingHours': 'Opening hours',
        'store.open': 'Opening hours',
        'store.orderFood': 'Order food delivery',
        'store.bookTable': 'Book a table',
        'store.seeMenu': 'See menu',
        'store.socialMedia': 'Follow us',
        'store.followUsFacebook': 'Follow us on Facebook',
        'store.followUsInstagram': 'Follow us on Instagram',
        'store.selectstore': 'Select store',
        'store.selectservice': 'Select service',
        'store.floorplan': 'Floorplan',
        'store.floormap': 'Floormap',
        'store.alphabetically': 'Alphabetically',
        'store.byCategory': 'By category',
        'store.byFloor': 'By floor',
        'store.giftCards': 'We welcome centre gift cards',
        'stores.exception.today': 'Stores\' exceptional opening hours today',
        'stores.exception.tomorrow': 'Stores\' exceptional opening hours tomorrow',
        'stores.exception.otherDay': 'Stores\' exceptional opening hours on',
        'stores.moreStores': 'More stores',
        'servicelocation.floors': 'Floors',
        'servicelocation.services': 'Services',
        'servicelocation.stores': 'Stores',
        'servicelocation.parking': 'Parking',
        'servicelocation.toilet': 'Toilet',
        'servicelocation.elevator': 'Elevator',
        'servicelocation.atm': 'ATM',
        'servicelocation.escalator': 'Escalator',
        'servicelocation.stairs': 'Stairs',
        'servicelocation.taxi': 'Taxi',
        'servicelocation.recycling': 'Recycling',
        'servicelocation.train': 'Train',
        'servicelocation.metro': 'Metro',
        'servicelocation.tram': 'Tram',
        'servicelocation.bus': 'Bus',
        'servicelocation.stop': 'Stop',
        'servicelocation.nurseryroom': 'Nursery room',
        'servicelocation.servicedesk': 'Info desk',
        'servicelocation.directory': 'Directory',
        'servicelocation.accessiblewc': 'Accessible WC',
        'servicelocation.bottlerecycling': 'Bottle recycling',
        'servicelocation.playground': 'Playground',
        'servicelocation.filterResult': 'Stores on floor',
        'servicelocation.servicesbyfloor': 'Show on map',
        'center.open': 'Shopping center is open',
        'center.close': 'Shopping center is closed',
        'fob-all': 'All stores',
        'fob-1010': 'Fashion',
        'fob-1020': 'Beauty & health',
        'fob-1030': 'Home & leisure',
        'fob-1040': 'Grocery',
        'fob-1050': 'Entertainment',
        'fob-1060': 'Other stores',
        'fob-1080': 'Restaurants',
        'fob-1090': 'Cafes',
        'fob-1100': 'Pubs & terraces',
        'fob-1110': 'Lunch',
        'fob-all-restaurants': 'Cafes and restaurants',
        'fob-kortelli': 'Kortteli',
        'feedback.required_fields_marked_by_star': 'Required fields',
        'feedback.target': 'Target',
        'feedback.choose_shop' : 'Choose a shop',
        'feedback.type_of_feedback' : 'Type of feedback',
        'feedback.message': 'Feedback',
        'feedback.target.general': 'General feedback',
        'feedback.target.store': 'Feedback to a specific company',
        'feedback.type.thanks': 'Thanks',
        'feedback.type.suggestion': 'Suggestion',
        'feedback.type.complaint': 'Complaint',
        'feedback.type.other': 'Other',
        'feedback.rsvp' : 'I would like to receive a reply',
        'feedback.privacy_statement' : 'Privacy policy',
        'feedback.thank_you' : 'Thank you for your feedback',
        'feedback.send': 'Send',
        'feedback.error.check_all_required_fields': 'Please check all required fields are filled',
        'feedback.error.field_required' : 'Field is required',
        'feedback.error.invalid_email_address' : 'Invalid email address',
        'feedback.error.please_choose_a_store' : 'Please choose a store',
    },
    'fi-FI': {
        'common.today':'Tänään',
        'common.back': 'Takaisin',
        'common.benefits': 'Tarjoukset',
        'common.next': 'Seuraava',
        'common.ok': 'OK',
        'common.previous': 'Edellinen',
        'common.readMore': 'Lue lisää',
        'common.readMoreFacebook': 'Lue lisää Facebookissa',
        'common.privacyPolicy': 'Rekisteriseloste',
        'common.downloadApp': 'Lataa sovellus',
        'common.buyGiftCards': 'Osta lahjakortteja',
        'common.orderNewsLetter': 'Tilaa uutiskirje',
        'common.seeOpeningHours': 'Olemme avoinna',
        'common.howToArrive': 'Saapuminen',
        'common.floormap': 'Pohjakartta',
        'common.openFloormap': 'Avaa pohjakartta',
        'common.storesOpenedAtLeast': 'Liikkeet auki tänään vähintään',
        'common.whatsNew': 'Tapahtumat',
        'common.viewMore': 'Katso lisää',
        'common.viewLess': 'Näytä vähemmän',
        'common.viewMoreNews': 'Lisää tapahtumia',
        'common.tomorrow': 'Huomenna',
        'common.dateSelector': 'Valitse päivä',
        'common.coming': 'Tulossa',
        'cookie.policy': 'Sivustomme käyttää evästeitä parhaan käyttökokemuksen takaamiseksi. Jatkamalla sivuston käyttöä hyväksyt evästeiden käytön.',
        'dayAgo': 'päivää sitten',
        'daysAgo': 'päivää sitten',
        'hourAgo': 'tunti sitten',
        'hoursAgo': 'tuntia sitten',
        'weekAgo': 'viikko sitten',
        'weeksAgo': 'viikkoa sitten',
        'week': 'viikko',
        'events.latestEvents': 'Uusimmat ajankohtaiset  uutiset',
        'events.events': 'Ajankohtaista',
        'events.otherEvents': 'MUITA AJANKOHTAISIA',
        'events.published': 'Julkaistu',
        'feedback.required_fields_marked_by_star': 'Pakolliset tiedot on merkitty tähdellä',
        'feedback.target': 'Kohde',
        'feedback.choose_shop' : 'Valitse liike',
        'feedback.type_of_feedback' : 'Palautteen tyyppi',
        'feedback.message': 'Palaute',
        'feedback.name' : 'Nimesi',
        'feedback.email' : 'Sähköpostiosoitteesi',
        'feedback.target.general': 'Haluan antaa yleistä palautetta',
        'feedback.target.store': 'Haluan antaa palautetta tietylle toimijalle',
        'feedback.type.thanks': 'Kiitos',
        'feedback.type.suggestion': 'Ehdotus',
        'feedback.type.complaint': 'Moite',
        'feedback.type.other': 'Muu',
        'feedback.rsvp' : 'Haluan, että minulle vastataan',
        'feedback.privacy_statement' : 'Rekisteriseloste',
        'feedback.thank_you' : 'Kiitos palautteesta!',
        'feedback.send': 'Lähetä',
        'feedback.error.check_all_required_fields': 'Tarkista, että kaikki pakolliset kentät on täytetty.',
        'feedback.error.field_required' : 'Kenttä on pakollinen',
        'feedback.error.invalid_email_address' : 'Osoite on virheellinen',
        'feedback.error.please_choose_a_store' : 'Tee valinta',
        'lunch.lunch': 'Lounas',
        'lunch.lunchTime': 'Lounasaika',
        'lunch.lunchToday': 'Tänään lounaalla',
        'lunch.openMenu': 'Avaa ruokalista (pdf)',
        'lunch.noMenu': 'Ei lounaslista',
        'lunch.today': 'Tänään',
        'lunch.orderFoodOnline': 'Tilaa ruokaa netistä',
        'lunch.bookTable': 'Varaa pöytä',
        'lunch.allRestaurant': 'See all restaurant',
        'lunch.orderFoodFromUs': 'Meiltä voit tilata ruokaa myös kotiin!',
        'lunch.lunchList': 'Lounaslista',
        'lunch.toRestaurantPage': 'Ravintolan sivulle',
        'lunch.searchLunchRestaurant': 'Etsi lounasravintolaa',
        'lunch.viewMore': 'Lisää ravintoloita',
        'offers.allOffers': 'Kaikki edut',
        'offers.closeOffer': 'Sulje',
        'offers.seeWholeOffer': 'Avaa koko tarjous',
        'offers.noOffers': 'Etuja ei valitettavasti tällä hetkellä ole saatavilla',
        'offers.noContent': 'Ei näytettävää sisältöä juuri nyt',
        'offers.fromCenter': 'Keskukselta',
        'offers.fromStores': 'Liikkeiltä',
        'offers.moreOffers': 'Katso lisää etuja',
        'offers.moreAboutOffer': 'Lisätietoja',
        'offers.valid': 'Voimassa',
        'openinghours.monday.short': 'Ma',
        'openinghours.monday': 'Maanantai',
        'openinghours.tuesday.short': 'Ti',
        'openinghours.tuesday': 'Tiistai',
        'openinghours.wednesday.short': 'Ke',
        'openinghours.wednesday': 'Keskiviikko',
        'openinghours.thursday.short': 'To',
        'openinghours.thursday': 'Torstai',
        'openinghours.friday.short': 'Pe',
        'openinghours.friday': 'Perjantai',
        'openinghours.saturday.short': 'La',
        'openinghours.saturday': 'Lauantai',
        'openinghours.sunday.short': 'Su',
        'openinghours.sunday': 'Sunnuntai',
        'openinghours.openedToday': 'Avoinna tänään',
        'openinghours.closedToday': 'Suljettu tänään',
        'openinghours.openedTomorrow': 'Avoinna huomenna',
        'openinghours.closedTomorrow': 'Suljettu huomenna',
        'openinghours.openedDayAfter': 'Avoinna ylihuomenna',
        'openinghours.dayAfter': 'Ylihuomenna',
        'openinghours.closedDayAfter': 'Suljettu ylihuomenna',
        'openinghours.seeAllCentreOpeningHours': 'Katso keskuksen aukiolot',
        'openinghours.displayAll': 'Katso kaikki',
        'openinghours.title': 'Aukioloajat',
        'search.stores': 'Liike',
        'search.articles': 'Artikkeli',
        'search.events': 'Ajankohtaiset',
        'search.noResults': 'Ei tuloksia',
        'search.placeholder': 'Hae',
        'search.forFood': 'Etsi ravintolaa, kahvilaa tai pubia',
        'search.forBrand': 'Etsi liikettä tai palvelua',
        'search.forOffers': 'Parhaat tarjoukset.',
        'store.allStores': 'Kaikki liikkeet',
        'store.allFloors': 'Kaikki',
        'store.allRestaurants': 'Kaikki Kahvilat ja ravintolat',
        'store.closed': 'Suljettu',
        'store.status.CLOSED': "Suljettu",
        'store.status.OPEN': "Auki",
        'store.contact': 'Yhteystiedot',
        'store.contactForm': 'Ota yhteyttä',
        'store.contactPrivatePolicyText': 'When you send a message, the store may contact you by email. We will not use your information for other purposes. By sending the form you agree to our',
        'store.message': 'Message',
        'store.exceptionalOpeningHours': 'Poikkeusaukioloajat',
        'store.seeExceptHours': 'Katso poikkeusaukioloajat',
        'store.filterSearch': 'Suodata hakua',
        'store.location': 'Katso sijainti kartalta',
        'store.openLunchMenu': 'Sepän lounaslistaan >',
        'store.lunchMenu': 'Lounaslista',
        'store.lunch': 'Lounaslista',
        'store.offers': 'Tarjoukset',
        'store.openingHours': 'Aukioloajat',
        'store.open': 'Avoinna',
        'store.orderFood': 'Tilaa kotiin varauspalvelusta',
        'store.bookTable': 'Varaa pöytä',
        'store.seeMenu': 'Katso ruokalista',
        'store.socialMedia': 'Seuraa meitä',
        'store.followUsFacebook': 'Seuraa meitä Facebookissa',
        'store.followUsInstagram': 'Seuraa meitä Instagramissa',
        'store.selectstore': 'Valitse liike',
        'store.selectservice': 'Valitse palvelu',
        'store.floorplan': 'Pohjakartta',
        'store.floormap': 'Pohjakartta',
        'store.alphabetically': 'Aakkosittain',
        'store.byCategory': 'Toimialoittain',
        'store.byFloor': 'Kerroksittain',
        'store.giftCards': 'Meillä voit maksaa kauppakeskuksen lahjakortilla',
        'stores.exception.today': 'Liikkeiden poikkeusaukiolot tänään',
        'stores.exception.tomorrow': 'Liikkeiden poikkeusaukiolot huomenna',
        'stores.exception.otherDay': 'Liikkeiden poikkeusaukiolot',
        'stores.moreStores': 'Lisää liikkeitä',
        'servicelocation.floors': 'Kerrokset',
        'servicelocation.services': 'Palvelut',
        'servicelocation.stores': 'Liikkeet',
        'servicelocation.parking': 'Pysäköinti',
        'servicelocation.toilet': 'WC',
        'servicelocation.elevator': 'Hissi',
        'servicelocation.atm': 'Pankkiautomaatti',
        'servicelocation.escalator': 'Rullaportaat',
        'servicelocation.stairs': 'Portaat',
        'servicelocation.taxi': 'Taksi',
        'servicelocation.recycling': 'Kierrätys',
        'servicelocation.train': 'Juna',
        'servicelocation.metro': 'Metro',
        'servicelocation.tram': 'Raitiovaunu',
        'servicelocation.bus': 'Linja-auto',
        'servicelocation.stop': 'Pysäkki',
        'servicelocation.nurseryroom': 'Lastenhoitohuone',
        'servicelocation.servicedesk': 'Infopiste',
        'servicelocation.directory': 'Hakemisto',
        'servicelocation.accessiblewc': 'Inva wc',
        'servicelocation.bottlerecycling': 'Pullonpalautus',
        'servicelocation.playground': 'Leikkipaikka',
        'servicelocation.filterResult': 'Liikkeet kerroksessa',
        'servicelocation.servicesbyfloor': 'Näytä kartalla',
        'center.open': 'Kauppakeskus on avoinna',
        'center.close': 'Kauppakeskus on suljettu',
        'fob-all': 'Kaikki liikkeet',
        'fob-1010': 'Muoti',
        'fob-1020': 'Kauneus & terveys',
        'fob-1030': 'Koti & vapaa-aika',
        'fob-1040': 'Päivittäistavarat',
        'fob-1050': 'Viihde',
        'fob-1060': 'Muut',
        'fob-1080': 'Ravintolat',
        'fob-1090': 'Kahvilat',
        'fob-1100': 'Pubit & terassit',
        'fob-1110': 'Lounas',
        'fob-all-restaurants': 'Kahvilat & ravintolat',
        'fob-kortelli': 'Kortteli',
    }

} as Localizations;

const provider: LocalizationsProvider = {
    namespace: theme_ns,
    localizations: translations,
};

export default provider;
